import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { PageStyleService } from '@reconcept-platform/shared/util';

@Component({
  selector: 'rcp-page-header-image',
  template: `<img [src]="src()" />`,
  styles: `
    :host {
      height: var(--standalone-page-fold-height);

      &.collapse-padding {
        margin: 0 calc(-1 * var(--app-page-padding));
      }

      &.collapse-padding-top {
        margin-top: calc(-1 * var(--app-page-padding));
      }

      img {
        height: 100%;
        width: 100%;
        object-fit: cover;
        object-position: var(--page-header-image-object-position, center);
      }
    }
  `,
  host: {
    '[class.collapse-padding]': 'isInStandalonePage()',
    '[class.collapse-padding-top]': 'isInStandalonePage() && collapsePaddingTop()',
  },
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class PageHeaderImageComponent {
  private readonly pageStyleService = inject(PageStyleService);

  readonly src = input.required<string>();

  // By default also enable bleeding to the top of the container
  // however, this may not be desired when used below another element,
  // for example a stepflow that shows a progress bar.
  readonly collapsePaddingTop = input(true);

  readonly isInStandalonePage = computed(() => this.pageStyleService.pageStyle() === 'standalone');
}
